var React = require('react');

function ButtonPlay (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"fill":"#fff","points":"13,8.5 0,17 0,0 "}));
}

ButtonPlay.defaultProps = {"version":"1.1","id":"Laag_1","x":"0px","y":"0px","viewBox":"0 0 13 17","style":{"enableBackground":"new 0 0 13 17"},"xmlSpace":"preserve"};

module.exports = ButtonPlay;

ButtonPlay.default = ButtonPlay;
